module.exports = __webpack_public_path__ + "img/purim-2018.9f4da564.jpg";